import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type UserPageShellWidth = "narrow" | "default" | "wide" | "full";

const WIDTH_CLASS_NAMES: Record<UserPageShellWidth, string> = {
  narrow: "theme-user-page-width--narrow",
  default: "theme-user-page-width--default",
  wide: "theme-user-page-width--wide",
  full: "theme-user-page-width--full",
};

type UserPageShellProps = {
  children: ReactNode;
  header?: ReactNode;
  width?: UserPageShellWidth;
  showGlow?: boolean;
  className?: string;
  mainClassName?: string;
};

export default function UserPageShell({
  children,
  header,
  width = "default",
  showGlow = true,
  className,
  mainClassName,
}: UserPageShellProps) {
  return (
    <div
      className={cn(
        "theme-session-page-root theme-page-bg relative isolate flex min-h-dvh w-full flex-col overflow-x-clip",
        className
      )}
    >
      {showGlow ? (
        <div className="theme-page-glow theme-shell-glow" aria-hidden="true" />
      ) : null}
      {header}
      <main
        className={cn(
          "theme-session-page-main theme-user-page-width mx-auto w-full",
          WIDTH_CLASS_NAMES[width],
          mainClassName
        )}
      >
        {children}
      </main>
    </div>
  );
}
